import exportFile from 'quasar/src/utils/export-file.js';

// const REST_ENDPOINT = 'http://localhost:2000/api/'
const REST_ENDPOINT = `https://betaportal.altmedia.ro:2000/api/`

export function getRestEndpoint () {
  return REST_ENDPOINT
}

export function wrapCsvValue (val, formatFn, row) {
    let formatted = formatFn !== void 0
      ? formatFn(val, row)
      : val

    formatted = formatted === void 0 || formatted === null
      ? ''
      : String(formatted)

    formatted = formatted.split('"').join('""')
    return `"${formatted}"`
}

export function exportTable (cols, rows, fileName, test) {
  let formattedDate = ''
  if (test) {
    formattedDate = test
  } else {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    formattedDate = `${year}.${month}.${day}`;
  }
  
  const content = [cols.map(col => wrapCsvValue(col.label))].concat(
    rows.map(row => cols.map(col => wrapCsvValue(
      typeof col.field === 'function'
        ? col.field(row)
        : row[ col.field === void 0 ? col.name : col.field ],
      col.format,
      row
    )).join(','))
  ).join('\r\n')
    return exportFile (
    fileName + formattedDate + '.csv',
    content,
    'text/csv'
  )
}